/* ============================================================
   Tool card — renders both live and planned tools.
   A planned tool is visibly planned rather than a dead link (A-22).
   ============================================================ */

import { icon } from '../shared/icons.js';
import { html, raw } from '../shared/html.js';
import { router } from '../shared/router.js';

export function ToolCard(tool) {
  const isLive = tool.status === 'live';
  const card = document.createElement(isLive ? 'button' : 'div');
  card.className = 'card card-link';
  card.style.marginBottom = 'var(--ca-space-3)';

  if (!isLive) card.setAttribute('aria-disabled', 'true');

  card.innerHTML = html`
    <div class="tool-card-body">
      <div
        class="tool-icon"
        style="background: color-mix(in srgb, ${tool.accent} 12%, transparent); color: ${tool.accent};"
      >
        ${raw(icon(tool.icon, 22))}
      </div>
      <div style="flex: 1; min-width: 0;">
        <h3>${tool.title}</h3>
        <p>${tool.summary}</p>
      </div>
      ${isLive
        ? html`<div style="color: var(--ca-text-quaternary);">${raw(icon('right', 18))}</div>`
        : html`<span class="badge" style="background: var(--ca-surface-sunk); color: var(--ca-text-tertiary);">
            ${tool.phase || 'Planned'}
          </span>`}
    </div>
  `;

  if (isLive) {
    card.type = 'button';
    card.addEventListener('click', () => router.navigate(tool.path));
  }

  return card;
}
